import React from 'react';
import { useTranslation } from 'react-i18next';
import { Button, DialogContentText, Modal, ModalProps } from '@p81-common/ui';
import { ModalDetails } from '../helpers/config';

interface ConfirmationModalProps {
  modalDetails: ModalDetails;
  open: ModalProps['open'];
  handleConfirmClick: (event?: React.MouseEvent) => void;
  handleCloseClick: (event?: React.MouseEvent) => void;
}

const ConfirmationModal = ({
  modalDetails,
  open,
  handleConfirmClick,
  handleCloseClick
}: ConfirmationModalProps) => {
  const { t } = useTranslation(['activity']);

  return (
    <Modal
      id="confirmationModal"
      open={open}
      dialogActionsProps={{
        children: (
          <>
            <Button variant="text" color="primary" onClick={handleCloseClick}>
              {t('activity:buttons.CANCEL')}
            </Button>
            <Button color="primary" onClick={handleConfirmClick}>
              {t('activity:buttons.YES')}
            </Button>
          </>
        )
      }}
      dialogContentProps={{
        children: (
          <DialogContentText>
            {t(
              'activity:customerEnvironment.CONFIRMATION_MODAL_CONTENT',
              modalDetails
            )}
          </DialogContentText>
        )
      }}
      dialogTitleProps={{
        children: t('activity:customerEnvironment.CONFIRMATION_MODAL_TITLE')
      }}
      onClose={handleCloseClick}
    />
  );
};

export default ConfirmationModal;
